import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { connect, ReactReduxContext } from 'react-redux';
import { AuthenticationState } from 'react-aad-msal';
import { Container, Row, Col, Button, Nav } from "react-bootstrap";
import { SideMenu } from "./SideMenu"; // Type defintitions

import * as TYPES from '../../types'; // Utilities

import * as UTIL from '../../util'; // Design System

import Logo from "../Logo";
import Modal from '../modal/Modal';
import Menu from './Menu';
import SecondaryMenu from './SecondaryMenu';
import AccountMenu from './AccountMenu'; // Forms

import SearchBarForm from '../forms/SearchBar'; // Redux

import { waitlistDuck } from "../../ducks/waitlist";
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { withCookies, Cookies } from 'react-cookie';
var waitlistOperations = waitlistDuck.operations;

var HeaderNav = /*#__PURE__*/function (_Component) {
  _inherits(HeaderNav, _Component);

  var _super = _createSuper(HeaderNav);

  // items = [];
  function HeaderNav(props) {
    var _this;

    _classCallCheck(this, HeaderNav);

    _this = _super.call(this, props);
    var cookies = props.cookies;
    _this.state = {
      modalTitle: 'Login',
      isVisible: false,
      formModalVisible: false,
      loginForm: true,
      searchActive: false,
      showPayInApp: props.showPayInApp || false,
      // MOBILE ONLY FEATURE
      hideBanner: false,
      hasInterval: cookies.get('hasInterval') || false
    };
    _this.handleLogin = _this.handleLogin.bind(_assertThisInitialized(_this));
    _this.handleAccoount = _this.handleAccoount.bind(_assertThisInitialized(_this));
    _this.handleLogout = _this.handleLogout.bind(_assertThisInitialized(_this));
    _this.handleShowModal = _this.handleShowModal.bind(_assertThisInitialized(_this));
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_this));
    _this.handleExit = _this.handleExit.bind(_assertThisInitialized(_this));
    _this.handleSidebar = _this.handleSidebar.bind(_assertThisInitialized(_this));
    _this.toggleSearch = _this.toggleSearch.bind(_assertThisInitialized(_this));
    _this.closeSearch = _this.closeSearch.bind(_assertThisInitialized(_this));
    _this.callHideBanner = _this.callHideBanner.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(HeaderNav, [{
    key: "handleShowModal",
    value: function handleShowModal() {
      this.setState({
        formModalVisible: true
      });
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.setState({
        formModalVisible: false
      });
    }
  }, {
    key: "handleExit",
    value: function handleExit() {
      this.setState({
        modalTitle: 'Login',
        loginForm: true
      });
    }
  }, {
    key: "handleLogin",
    value: function handleLogin() {
      if (typeof this.props.handleLogin === 'function') {
        return this.props.handleLogin();
      }

      return false;
    }
  }, {
    key: "handleSidebar",
    value: function handleSidebar() {
      if (typeof this.props.toggleSidenav === 'function') {
        return this.props.toggleSidenav();
      }

      return false;
    }
  }, {
    key: "handleAccoount",
    value: function handleAccoount() {
      if (typeof this.props.toggleAccountnav === 'function') {
        return this.props.toggleAccountnav();
      }

      return false;
    }
  }, {
    key: "handleLogout",
    value: function handleLogout() {
      if (typeof this.props.handleLogout === 'function') {
        return this.props.handleLogout();
      }

      return false;
    }
  }, {
    key: "toggleSearch",
    value: function toggleSearch(e) {
      this.setState({
        searchActive: !this.state.searchActive
      });
    }
  }, {
    key: "closeSearch",
    value: function closeSearch(e) {
      if (this.state.searchActive) {
        this.setState({
          searchActive: false
        });
      }
    }
  }, {
    key: "callHideBanner",
    value: function callHideBanner() {
      this.setState({
        hideBanner: true
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$state;

      var _this$props = this.props,
          _this$props$getShopCa = _this$props.getShopCategories,
          getShopCategories = _this$props$getShopCa === void 0 ? function () {
        return console.log("getShopCategories");
      } : _this$props$getShopCa,
          cookies = _this$props.cookies;

      if (((_this$state = this.state) === null || _this$state === void 0 ? void 0 : _this$state.hasInterval) === false && (window.location.pathname.includes('/shop') || window.location.pathname == '/')) {
        getShopCategories();
        cookies.set('hasInterval', true, {
          path: '/'
        });
        this.setState({
          hasInterval: true
        });
      }

      var interval = 14400000; // 4 hours to Milliseconds

      setInterval(function () {
        getShopCategories();
      }, interval);

      if (UTIL.loginUrl()) {
        if (typeof this.props.handleLogin === 'function' && this.props.authenticationState !== AuthenticationState.Authenticated) {
          return this.props.handleLogin();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          _this$props2$secondar = _this$props2.secondaryNavVisible,
          secondaryNavVisible = _this$props2$secondar === void 0 ? false : _this$props2$secondar,
          _this$props2$accountN = _this$props2.accountNavVisible,
          accountNavVisible = _this$props2$accountN === void 0 ? false : _this$props2$accountN,
          model = _this$props2.model,
          searchResults = _this$props2.searchResults,
          _this$props2$navigati = _this$props2.navigation,
          navigation = _this$props2$navigati === void 0 ? {} : _this$props2$navigati,
          _this$props2$hamburge = _this$props2.hamburgerMenuLinks,
          hamburgerMenuLinks = _this$props2$hamburge === void 0 ? {} : _this$props2$hamburge,
          _this$props2$hamburge2 = _this$props2.hamburgerMenuButtons,
          hamburgerMenuButtons = _this$props2$hamburge2 === void 0 ? {} : _this$props2$hamburge2,
          toggleWaitlist = _this$props2.toggleWaitlist,
          searchChangeHandler = _this$props2.searchChangeHandler,
          searchSubmitHandler = _this$props2.searchSubmitHandler,
          authenticationState = _this$props2.authenticationState,
          accountInfo = _this$props2.accountInfo,
          newItem = _this$props2.newItem,
          addTo = _this$props2.addTo,
          cart = _this$props2.cart,
          _this$props2$close = _this$props2.close,
          close = _this$props2$close === void 0 ? function () {
        return "";
      } : _this$props2$close,
          shopNav = _this$props2.shopNav,
          isCnbSite = _this$props2.isCnbSite,
          isStorePortal = _this$props2.isStorePortal,
          offlineCart = _this$props2.offlineCart;
      var value = UTIL.mapNav(shopNav) || [];
      navigation.children = navigation.children.map(function (child) {
        if (child.url === "/shop") {
          child.children = value;
        }

        return child;
      });
      var _cart$cart = cart.cart,
          reduxCart = _cart$cart === void 0 ? [] : _cart$cart;
      var _this$state2 = this.state,
          formModalVisible = _this$state2.formModalVisible,
          modalTitle = _this$state2.modalTitle,
          loginForm = _this$state2.loginForm,
          searchActive = _this$state2.searchActive,
          showPayInApp = _this$state2.showPayInApp;
      var items = navigation.children || [];

      if (isStorePortal) {
        return !UTIL.hideFooterHeader() && /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (context) {
          var _this2$props, _this2$props$context, _this2$props$context$;

          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SecondaryMenu, _extends({}, _this2.props, {
            authenticationState: authenticationState,
            secondaryNavVisible: secondaryNavVisible,
            onHide: _this2.handleSidebar,
            onLogin: _this2.handleLogin,
            handleLogout: _this2.handleLogout,
            handleShowSidebar: _this2.handleSidebar,
            toggleWaitlist: toggleWaitlist,
            links: hamburgerMenuLinks,
            buttons: hamburgerMenuButtons,
            model: model,
            showPayInApp: showPayInApp,
            openPayInApp: (_this2$props = _this2.props) === null || _this2$props === void 0 ? void 0 : (_this2$props$context = _this2$props.context) === null || _this2$props$context === void 0 ? void 0 : (_this2$props$context$ = _this2$props$context.props) === null || _this2$props$context$ === void 0 ? void 0 : _this2$props$context$.openPayInApp,
            isStorePortal: isStorePortal
          })), /*#__PURE__*/React.createElement(HeaderWrapper, {
            isCnbSite: isCnbSite
          }, /*#__PURE__*/React.createElement(CoreNav, {
            model: model,
            searchActive: searchActive,
            handleAccoount: _this2.handleAccoount,
            handleLogin: _this2.handleLogin,
            handleLogout: _this2.handleLogout,
            handleShowModal: _this2.handleShowModal,
            handleSidebar: _this2.handleSidebar,
            closeSearch: _this2.closeSearch,
            toggleSearch: _this2.toggleSearch,
            authenticationState: authenticationState,
            accountInfo: accountInfo,
            items: items,
            cartLength: offlineCart.length,
            isCnbSite: isCnbSite,
            isStorePortal: isStorePortal
          }), /*#__PURE__*/React.createElement(MobileSidebar, {
            searchActive: searchActive,
            handleAccoount: _this2.handleAccoount,
            handleLogin: _this2.handleLogin,
            handleLogout: _this2.handleLogout,
            handleShowModal: _this2.handleShowModal,
            handleShowSidebar: _this2.handleSidebar,
            closeSearch: _this2.closeSearch,
            displaySearch: _this2.toggleSearch,
            authenticationState: authenticationState,
            accountInfo: accountInfo,
            cartLength: offlineCart.length,
            isCnbSite: isCnbSite,
            isStorePortal: isStorePortal
          })));
        }.bind(this));
      }

      if (isCnbSite) {
        return !UTIL.hideFooterHeader() && /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (context) {
          var _this2$props2, _this2$props2$context, _this2$props2$context2;

          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SecondaryMenu, _extends({}, _this2.props, {
            authenticationState: authenticationState,
            secondaryNavVisible: secondaryNavVisible,
            onHide: _this2.handleSidebar,
            onLogin: _this2.handleLogin,
            handleShowSidebar: _this2.handleSidebar,
            toggleWaitlist: toggleWaitlist,
            links: hamburgerMenuLinks,
            buttons: hamburgerMenuButtons,
            model: model,
            showPayInApp: showPayInApp,
            openPayInApp: (_this2$props2 = _this2.props) === null || _this2$props2 === void 0 ? void 0 : (_this2$props2$context = _this2$props2.context) === null || _this2$props2$context === void 0 ? void 0 : (_this2$props2$context2 = _this2$props2$context.props) === null || _this2$props2$context2 === void 0 ? void 0 : _this2$props2$context2.openPayInApp
          })), /*#__PURE__*/React.createElement(AccountMenu, {
            accountNavVisible: accountNavVisible,
            onHide: _this2.handleAccoount,
            handleLogout: _this2.handleLogout,
            model: model
          }), /*#__PURE__*/React.createElement(HeaderWrapper, {
            isCnbSite: isCnbSite
          }, /*#__PURE__*/React.createElement(CoreNav, {
            model: model,
            searchActive: searchActive,
            handleAccoount: _this2.handleAccoount,
            handleLogin: _this2.handleLogin,
            handleShowModal: _this2.handleShowModal,
            handleSidebar: _this2.handleSidebar,
            closeSearch: _this2.closeSearch,
            toggleSearch: _this2.toggleSearch,
            authenticationState: authenticationState,
            accountInfo: accountInfo,
            items: items,
            cartLength: reduxCart.length,
            isCnbSite: isCnbSite
          }), /*#__PURE__*/React.createElement(MobileSidebar, {
            searchActive: searchActive,
            handleAccoount: _this2.handleAccoount,
            handleLogin: _this2.handleLogin,
            handleShowModal: _this2.handleShowModal,
            handleShowSidebar: _this2.handleSidebar,
            closeSearch: _this2.closeSearch,
            displaySearch: _this2.toggleSearch,
            authenticationState: authenticationState,
            accountInfo: accountInfo,
            cartLength: reduxCart.length,
            isCnbSite: isCnbSite
          })));
        }.bind(this));
      }

      return !UTIL.hideFooterHeader() && /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (context) {
        var _this2$props3, _this2$props3$context, _this2$props3$context2, _this2$props4, _this2$props4$context, _this2$props4$context2;

        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SecondaryMenu, _extends({}, _this2.props, {
          store: _this2.props.store,
          authenticationState: authenticationState,
          secondaryNavVisible: secondaryNavVisible,
          onHide: _this2.handleSidebar,
          onLogin: _this2.handleLogin,
          handleShowSidebar: _this2.handleSidebar,
          toggleWaitlist: toggleWaitlist,
          links: hamburgerMenuLinks,
          buttons: hamburgerMenuButtons,
          model: model,
          showPayInApp: showPayInApp,
          openPayInApp: (_this2$props3 = _this2.props) === null || _this2$props3 === void 0 ? void 0 : (_this2$props3$context = _this2$props3.context) === null || _this2$props3$context === void 0 ? void 0 : (_this2$props3$context2 = _this2$props3$context.props) === null || _this2$props3$context2 === void 0 ? void 0 : _this2$props3$context2.openPayInApp
        })), /*#__PURE__*/React.createElement(AccountMenu, {
          accountNavVisible: accountNavVisible,
          onHide: _this2.handleAccoount,
          handleLogout: _this2.handleLogout,
          model: model
        }), /*#__PURE__*/React.createElement(HeaderWrapper, {
          isCnbSite: isCnbSite
        }, /*#__PURE__*/React.createElement(CoreNav, {
          model: model,
          searchActive: searchActive,
          handleAccoount: _this2.handleAccoount,
          handleLogin: _this2.handleLogin,
          handleShowModal: _this2.handleShowModal,
          handleSidebar: _this2.handleSidebar,
          closeSearch: _this2.closeSearch,
          toggleSearch: _this2.toggleSearch,
          authenticationState: authenticationState,
          accountInfo: accountInfo,
          items: items,
          cartLength: reduxCart.length
        }), /*#__PURE__*/React.createElement(SearchBar, {
          searchActive: _this2.state.searchActive,
          searchChangeHandler: searchChangeHandler,
          searchResults: searchResults
        }), /*#__PURE__*/React.createElement(MobileSidebar, {
          searchActive: searchActive,
          handleAccoount: _this2.handleAccoount,
          handleLogin: _this2.handleLogin,
          handleShowModal: _this2.handleShowModal,
          handleShowSidebar: _this2.handleSidebar,
          closeSearch: _this2.closeSearch,
          displaySearch: _this2.toggleSearch,
          authenticationState: authenticationState,
          accountInfo: accountInfo,
          cartLength: reduxCart.length
        })), /*#__PURE__*/React.createElement(BannerCopy, {
          callHideBanner: _this2.callHideBanner,
          hideBanner: _this2.state.hideBanner,
          bannerModel: (_this2$props4 = _this2.props) === null || _this2$props4 === void 0 ? void 0 : (_this2$props4$context = _this2$props4.context) === null || _this2$props4$context === void 0 ? void 0 : (_this2$props4$context2 = _this2$props4$context.fields) === null || _this2$props4$context2 === void 0 ? void 0 : _this2$props4$context2.bannerCopy
        }));
      }.bind(this));
    }
  }]);

  return HeaderNav;
}(Component);

;

var mapStateToProps = function mapStateToProps(state) {
  return _objectSpread({}, state);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    toggleWaitlist: function toggleWaitlist() {
      return dispatch(waitlistOperations.toggleWaitlist());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderNav);
export { SecondaryMenu };
export var BannerCopy = function BannerCopy(props) {
  var _bannerModel$jss;

  var hideBanner = props.hideBanner,
      bannerModel = props.bannerModel,
      callHideBanner = props.callHideBanner;
  var bannerText = bannerModel ? bannerModel === null || bannerModel === void 0 ? void 0 : (_bannerModel$jss = bannerModel.jss) === null || _bannerModel$jss === void 0 ? void 0 : _bannerModel$jss.value : 'Banner text not found';
  return /*#__PURE__*/React.createElement(React.Fragment, null, bannerText !== "" && bannerText && /*#__PURE__*/React.createElement("div", {
    id: "RSAlert",
    class: "RSAlert-light ".concat(hideBanner && "inactive")
  }, /*#__PURE__*/React.createElement(RichText, {
    field: {
      value: bannerText
    },
    tag: "span"
  }), /*#__PURE__*/React.createElement("button", {
    className: "closeRSAlert",
    onClick: callHideBanner
  }, "\xD7")));
};
export var CoreNav = function CoreNav(props) {
  var model = props.model,
      searchActive = props.searchActive,
      handleShowModal = props.handleShowModal,
      handleLogin = props.handleLogin,
      handleAccoount = props.handleAccoount,
      handleSidebar = props.handleSidebar,
      closeSearch = props.closeSearch,
      toggleSearch = props.toggleSearch,
      authenticationState = props.authenticationState,
      accountInfo = props.accountInfo,
      items = props.items,
      cartLength = props.cartLength,
      isCnbSite = props.isCnbSite,
      isStorePortal = props.isStorePortal;
  var hideCleanedItem = UTIL.cleanObject(items, 'hideInNavigation');
  var cleanedItem = UTIL.cleanTitleObject(hideCleanedItem, 'navigationTitle'); // useEffect(() => {
  // },[cartLength])

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, {
    lg: "auto",
    md: "auto",
    sm: "6",
    xs: "6",
    className: "align-self-center cb-header--proverride"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-header__logo--lg ".concat(isCnbSite ? "cnb-logo" : "")
  }, /*#__PURE__*/React.createElement(Logo, {
    model: model
  }), " ")), /*#__PURE__*/React.createElement(Col, {
    sm: "6",
    xs: "6",
    className: "justify-content-end align-self-center d-flex d-sm-none cb-header__mobiledisplay"
  }, /*#__PURE__*/React.createElement(Nav, {
    as: "ul",
    className: "cb-header__navbar-secondary"
  }, /*#__PURE__*/React.createElement(SideMenu, {
    searchActive: searchActive,
    mobile: true,
    handleShowModal: handleShowModal,
    handleLogin: handleLogin,
    handleAccoount: handleAccoount,
    handleShowSidebar: handleSidebar,
    closeSearch: closeSearch,
    displaySearch: toggleSearch,
    authenticationState: authenticationState,
    accountInfo: accountInfo,
    cartLength: cartLength,
    isCnbSite: isCnbSite,
    isStorePortal: isStorePortal
  }))), /*#__PURE__*/React.createElement(Col, {
    lg: "auto",
    md: "auto",
    className: "cb-header__navbar-container align-self-center cb-header--poverride"
  }, /*#__PURE__*/React.createElement(Menu, {
    items: cleanedItem,
    handleLogin: handleLogin,
    handleShowModal: handleShowModal,
    handleAccoount: handleAccoount,
    authenticationState: authenticationState,
    accountInfo: accountInfo,
    isCnbSite: isCnbSite
  })));
};
export var SearchBar = function SearchBar(_ref) {
  var searchActive = _ref.searchActive,
      searchChangeHandler = _ref.searchChangeHandler,
      searchSubmitHandler = _ref.searchSubmitHandler,
      searchResults = _ref.searchResults;
  return /*#__PURE__*/React.createElement(Col, {
    className: "cb-header__search align-self-center d-block"
  }, /*#__PURE__*/React.createElement(SearchBarForm, {
    className: searchActive ? 'is-active' : '',
    changeHandler: searchChangeHandler,
    submitHandler: searchSubmitHandler,
    results: searchResults
  }));
};
export var MobileSidebar = function MobileSidebar(props) {
  var searchActive = props.searchActive,
      handleLogin = props.handleLogin,
      handleAccoount = props.handleAccoount,
      handleShowModal = props.handleShowModal,
      handleShowSidebar = props.handleShowSidebar,
      closeSearch = props.closeSearch,
      authenticationState = props.authenticationState,
      accountInfo = props.accountInfo,
      toggleSearch = props.toggleSearch,
      cartLength = props.cartLength,
      isCnbSite = props.isCnbSite,
      isStorePortal = props.isStorePortal;
  return /*#__PURE__*/React.createElement(Col, {
    className: "align-self-center d-none d-md-block cb-header__sideMenu ".concat(isCnbSite ? "cnb-nav-btn-wrapper" : "")
  }, /*#__PURE__*/React.createElement(SideMenu, {
    searchActive: searchActive,
    mobile: false,
    handleLogin: handleLogin,
    handleAccoount: handleAccoount,
    handleShowModal: handleShowModal,
    handleShowSidebar: handleShowSidebar,
    closeSearch: closeSearch,
    authenticationState: authenticationState,
    accountInfo: accountInfo,
    displaySearch: toggleSearch,
    cartLength: cartLength,
    isCnbSite: isCnbSite,
    isStorePortal: isStorePortal
  }));
};
export var HeaderWrapper = function HeaderWrapper(_ref2) {
  var children = _ref2.children,
      isCnbSite = _ref2.isCnbSite;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-header a cb-bg-clay-wood"
  }, /*#__PURE__*/React.createElement(Container, {
    className: "cb-header__container d-flex h-100"
  }, /*#__PURE__*/React.createElement(Row, {
    className: " ".concat(isCnbSite ? "justify-content-start" : "justify-content-center")
  }, children)));
};